var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7698 7.72348C39.5577 3.66082 33.9577 1.42383 28.0001 1.42383C22.0424 1.42383 16.4424 3.66082 12.2304 7.72348C3.53616 16.1072 3.53616 29.7496 12.2304 38.1343L26.6471 52.0351C27.0201 52.3958 27.5101 52.5762 28.0001 52.5762C28.4901 52.5762 28.9801 52.3958 29.353 52.0351L43.7698 38.1343C52.464 29.7496 52.464 16.1072 43.7698 7.72348ZM28.0001 32.4517C25.3619 32.4517 22.8824 31.4613 21.0165 29.6631C19.1516 27.8638 18.1246 25.4728 18.1246 22.9289C18.1246 20.385 19.1516 17.993 21.0165 16.1947C22.8824 14.3965 25.3619 13.4051 28.0001 13.4051C30.6382 13.4051 33.1177 14.3965 34.9837 16.1947C38.8337 19.9083 38.8337 25.9495 34.9837 29.6631C33.1177 31.4613 30.6382 32.4517 28.0001 32.4517Z",
    fill: "#0081D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.93c4e0c4ceed4223a2a7fe009d24fcbf.svg";
export { ForwardRef as ReactComponent };